var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "255mm",
    viewBox: "0 0 255 255",
    width: "255mm",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.422 284.473 14.738-13.265m159.747-116.034-40.204-37.631M156.6 105.6l39.861 39.032m-29.388-51.044-142.87 136.16-12.792 54.737 58.06-13.29 140.34-135.067zm.084-.083a31.849 31.849 0 0 1 13.757-8.089 31.849 31.849 0 0 1 15.954-.357c5.176 1.225 10.039 3.783 13.936 7.403 3.897 3.62 6.814 8.296 8.289 13.407a28.976 28.976 0 0 1 .117 15.551 28.976 28.976 0 0 1-7.985 13.345M24.204 229.747l24.273-2.53-1.64 23.413 23.618-2.531-.984 23.097m.984-23.097 89.55-85.113m-111.528 64.23 88.895-85.428",
    fill: "none",
    stroke: "#b23339",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.869,
    transform: "matrix(1.12326 0 0 1.16452 -1.395 -88.815)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBranch);
export default __webpack_public_path__ + "static/media/edit-branch.aa85a5354f4cd37b248da76aa3316392.svg";
export { ForwardRef as ReactComponent };